import { Injectable } from '@angular/core';
import { BaseQuery } from '../base/base.query';
import { SectionStore } from './section.store';

@Injectable({
    providedIn: 'root'
})
export class SectionQuery extends BaseQuery {

  constructor(store: SectionStore) {
        super(store);
    }


}
